import ApplicantNavData from "./ApplicantNavData";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const ApplicantNav = () => {
  const navigate = useNavigate();
  const applicantLoginData = useSelector(
    (state) => state.user.applicantLoginData
  );

  const hasOfferRollout = applicantLoginData?.process.some(
    (item) => item.interview?.status === "Offer rollout"
  );

  const filteredATSData = hasOfferRollout
    ? ApplicantNavData
    : ApplicantNavData.filter((item) => item.label !== "Upload Docs");

  return (
    <div className="flex grow flex-col gap-y-5 overflow-y-auto border-r h-screen border-gray-200 bg-white">
      <nav className="flex flex-1 flex-col">
        <ul role="list" className="flex flex-1 flex-col gap-y-7">
          <li>
            <ul role="list" className="-ml-2">
              {filteredATSData?.map(({ Icon, ...i }, index) => (
                <li key={index}>
                  <button
                    key={i.id}
                    onClick={() => navigate(i.to)}
                    className="flex w-full items-center gap-x-3 p-3 text-left  hover:bg-gray-100"
                  >
                    <img
                      src={Icon}
                      alt={i.label}
                      className="imagestyle w-5 h-5"
                    />
                    <span className="text-lg font-medium">{i.label}</span>
                  </button>
                </li>
              ))}
            </ul>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default ApplicantNav;
